import { lazy } from 'react';
const LtxTransit = lazy(() => import('./LtxTransit'));

const LtxTransitRoutes = [
  {
    path: '/ltxtransit',
    component: LtxTransit
  }
];

export default LtxTransitRoutes;
